module.exports = __webpack_public_path__ + "img/map_car_icon.3fe2b338.svg";